import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";

class QuotePreDeclinedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }


    render() {
        return <div className={"row " + this.state.className}>
            <div className={'col-12 d-flex align-items-start'}>
                <div className={'mr-3'}>
                    <h3 className={"m-0 text-warning"}>
                        <Icon value={"times-circle"} />
                    </h3>
                </div>
                <div >
                    <p className={'mb-1'}>
                        <FormattedMessage
                            id="quote.analytics.events.pre_declined.text"
                            defaultMessage="Proposal {identifier} has been refused by {name}"
                            values={{
                                identifier: <strong>{this.state.quote.attributes.identifier}</strong>,
                                name: <strong>{this.state.proposal.attributes.variables.customer.name}</strong>,
                            }}
                        />
                    </p>
                    <div className={'w-100'}>
                        <blockquote className="blockquote mb-0">
                            <p className="mb-0">{this.state.quote.attributes.notes.split('\n').map((item, key) => {
                                return <span key={key}>{item}<br /></span>
                            })}</p>
                            <footer className="blockquote-footer">{this.state.proposal.attributes.variables.customer.name}</footer>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default QuotePreDeclinedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/quote-pre-declined.component.jsx